module.exports = __webpack_public_path__ + "01ea978f/img/splash-icon.07a7c465.svg";